export enum ChangePasswordErrorTypes {
  WrongPassword = 'wrong-password',
  WeakPassword = 'weak-password',
  Unknown = 'unknown',
}
